import qs from 'querystring';

export default function getQueryParams(search) {
  const queryString = (search && search[0] === '?') ? search.slice(1) : search;
  return qs.parse(queryString);
}
